import { Component, OnInit, Input } from '@angular/core';
import { Dashboard } from 'src/app/core/services/dashboards.service';

@Component({
  selector: 'app-dashboard-menu-item',
  templateUrl: './dashboard-menu-item.component.html',
  styleUrls: ['./dashboard-menu-item.component.scss']
})
export class DashboardMenuItemComponent implements OnInit {

  @Input() dashboard: Dashboard;

  constructor() { }

  ngOnInit() {
  }

}
